import React from 'react'
import clsx from 'clsx'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Chip } from '@material-ui/core'

import helpers from 'helpers'

import constants from 'constants/index'

const dataSubjectInfo = (ticket, classes) => {
  const {
    COMPLETED_STATUS_ID,
    CANCELED_TICKET_ID,
    STATUS_TRANSLATION_LABELS,
    STATUS_CHIP_CLASSNAME,
    PENDING_STATUS_ID,
  } = constants.tickets

  const { dates, cpf } = helpers.formatters

  const isFinished =
    ticket?.status?.id === COMPLETED_STATUS_ID ||
    ticket?.status?.id === CANCELED_TICKET_ID

  const isOverdue =
    ticket?.companyStatus?.id === PENDING_STATUS_ID &&
    ticket?.companyDeadlineDate &&
    moment(ticket.companyDeadlineDate).isBefore(moment())

  const cpfComplete = ticket?.user?.document
    ? ticket.user.document.length > 3
    : false

  const answerValue = (answer) => {
    if (answer?.options?.length)
      return answer.options.map((o) => o.title).join(', ')
    return answer?.title || undefined
  }

  const responsibleValue = (responsible) =>
    responsible
      ? [responsible.name || 'Não informado', cpf(responsible.document || '')]
      : []

  const subOptionRows = (answer) => {
    if (!answer) return []

    if (answer.subOptions?.length) {
      return answer.subOptions.map((sub) => {
        const subValue = sub.answers
          ? sub.answers.map((a) => a.title).join(', ')
          : sub.subAnswers?.join(', ') ?? sub.subAnswer
        return {
          label: sub.title,
          value: [subValue].filter(Boolean),
          visible: true,
        }
      })
    }

    if (answer.subOption) {
      const sub = answer.subOption
      const subValue =
        sub.answers?.map((a) => a.title).join(', ') ??
        sub.subAnswers?.join(', ') ??
        sub.subAnswer
      return [
        { label: sub.title, value: [subValue].filter(Boolean), visible: true },
      ]
    }

    return []
  }

  const specificFieldRows = (answer) => {
    if (!answer) return []
    const specificField = answer.specificField
    if (!specificField) return []

    if (Array.isArray(specificField)) {
      return specificField.map((field) => ({
        label: field.title,
        value: field.response,
        visible: true,
      }))
    }

    return [
      {
        label: specificField.title,
        value: specificField.response,
        visible: true,
      },
    ]
  }

  return [
    {
      label: 'Título da solicitação',
      value: ticket?.title,
      visible: true,
      highlight: true,
    },
    {
      label: ticket?.info?.questionRequest?.title,
      value: [answerValue(ticket?.info?.questionRequest?.answer)].filter(
        Boolean,
      ),
      visible: true,
    },
    ...subOptionRows(ticket?.info?.questionRequest?.answer),
    ...specificFieldRows(ticket?.info?.questionRequest?.answer),
    ...(ticket?.info?.questionRequest?.answer?.responsible
      ? [
          {
            label: 'Titular de dados',
            value: responsibleValue(
              ticket?.info?.questionRequest?.answer?.responsible,
            ),
            visible: true,
          },
        ]
      : []),
    {
      label: ticket?.info?.questionRelationshipSelf?.title,
      value: [
        answerValue(ticket?.info?.questionRelationshipSelf?.answer),
      ].filter(Boolean),
      visible: !!ticket?.info?.questionRelationshipSelf,
    },
    ...subOptionRows(ticket?.info?.questionRelationshipSelf?.answer),
    ...specificFieldRows(ticket?.info?.questionRelationshipSelf?.answer),
    ...(ticket?.info?.questionRelationshipSelf?.answer?.responsible
      ? [
          {
            label: 'Titular de dados',
            value: responsibleValue(
              ticket?.info?.questionRelationshipSelf?.answer?.responsible,
            ),
            visible: true,
          },
        ]
      : []),
    {
      label: ticket?.info?.questionDemand?.title,
      value: [answerValue(ticket?.info?.questionDemand?.answer)].filter(
        Boolean,
      ),
      visible: !!ticket?.info?.questionDemand,
    },
    ...subOptionRows(ticket?.info?.questionDemand?.answer),
    ...specificFieldRows(ticket?.info?.questionDemand?.answer),
    ...(ticket?.info?.questionDemand?.answer?.responsible
      ? [
          {
            label: 'Titular de dados',
            value: responsibleValue(
              ticket?.info?.questionDemand?.answer?.responsible,
            ),
            visible: true,
          },
        ]
      : []),
    {
      label: cpfComplete ? 'CPF completo' : 'Três primeiros dígitos do CPF',
      value: cpf(ticket?.user?.document),
      visible: true,
    },
    {
      label: 'Solicitante',
      value: [
        ticket?.user?.name && ticket?.user?.name,
        ticket?.user?.email && ticket?.user?.email,
        ticket?.user?.phone && ticket?.user?.phone,
      ].filter(Boolean),
      visible: true,
    },
    {
      label: 'Controle de prazos',
      value: [
        ticket?.companyDeadlineDate &&
          `Prazo para atendimento: ${dates.ptBrFormatDate(
            ticket?.companyDeadlineDate,
            'Não possui data definida',
          )}`,
        `Data de criação: ${dates.ptBrFormatDateTime(ticket?.createdAt)}`,
        ticket?.confirmedAt &&
          `Data de confirmação: ${dates.ptBrFormatDateTime(
            ticket?.confirmedAt,
            'Não possui data definida',
          )}`,
        isFinished &&
          `Data de resolução: ${dates.ptBrFormatDateTime(
            ticket?.resolvedAt,
            'Não possui data definida',
          )}`,
      ].filter(Boolean),
      visible: true,
    },
    {
      label: 'Status',
      value: (
        <Chip
          label={
            isOverdue
              ? 'Atrasada'
              : STATUS_TRANSLATION_LABELS[ticket?.companyStatus?.id] ||
                ticket?.status?.name
          }
          size="small"
          className={clsx(
            classes.chip,
            classes.fullChip,
            isOverdue
              ? classes.overdue
              : classes[STATUS_CHIP_CLASSNAME[ticket?.companyStatus?.id]] || '',
          )}
        />
      ),
      visible: true,
    },
  ]
}

dataSubjectInfo.propTypes = {
  ticket: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default dataSubjectInfo
